import DialogController from "./dialog_controller"

// Keep nested forms and print buttons independent from row activation.
export default class extends DialogController {
  get initialReturnFocus() { return this.hasTriggerTarget ? this.triggerTarget : null }

  activate(event) {
    if (event.target.closest("a, button, input, select, textarea, label, dialog")) return
    if (event.type === "keydown" && event.target !== this.element) return
    event.preventDefault()
    this.open(event)
  }
}
